import React from 'react';

import { makeStyles, useTheme } from '@mui/styles';

import Paper from '@mui/material/Paper';
import { Button, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '@mui/material/CircularProgress';

import { Modal } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import UserService from "../../services/user.service";
import { useState, useEffect } from 'react'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Excel from "../Excel.component";
import { useStyles, theme, direction } from '../styles'; // Importa los estilos desde el archivo styles.js

//Validacion del formulario
const validationSchema = yup.object();

export default function InformeRecursos(props) {
    const [isLoading, setIsLoading] = useState(false)
    const [datayacimientos, setDatayacimientos] = useState([]);
    const [dataequipos, setDataequipos] = useState([]);

    const [left, setLeft] = useState([]);
    const [data, setData] = useState([]);
    const [modalQR, setModalQR] = useState(false);
    const [values, setValues] = useState([]);
    const [open, setOpen] = React.useState(false);

    const [estado, setEstado] = useState([
        { id: 'En proceso', nombre: 'En proceso' },
        { id: 'Entregado', nombre: 'Entregado' },
        { id: 'Operativo', nombre: 'Operativo' },
        { id: 'En reparacion', nombre: 'En reparacion' },
        { id: 'Fuera de servicio', nombre: 'Fuera de servicio' },
    ]);

    const handleChange = e => {
        const { name, value } = e.target;
        if (name === 'empresa') {
            formik.values.empresa = value;
            getYacimiento(value);
        }
        if (name === 'yacimiento') {
            formik.values.yacimiento = value;
            getEquipo(value);
        }
    }

    const getYacimiento = async (id) => {
        const response = await UserService.getYacimientosid(id);
        setDatayacimientos(response.data);
    }

    const getEquipo = async (id) => {
        const response = await UserService.getEquiposid(id);
        setDataequipos(response.data);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const abrirCerrarModalQR = () => {
        setModalQR(!modalQR);
    }

    const peticionPost = async (data) => {
        const response = await UserService.getInformeRecursos(data);
        if (response.data == null) {
            setOpen(true);
            //setModalQR(!modalQR);
        } else {
            abrirCerrarModalQR();
            setValues(response.data);
        }
        //cerrarEditar()
    }

    //inicializacion de variables y validacion
    const formik = useFormik({
        initialValues: {
            fechainicio: '',
            fechafin: '',
            empresa: '',
            yacimiento: '',
            serie: '',
            sap: '',
            estado: '',
            equipo: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            peticionPost(values);
            //abrirCerrarModalQR();
        },
    });

    const styles = useStyles();
    const classes = useStyles();

    const cerrarEditar = () => {
        props.history.push("/empresas");
    }

    useEffect(() => {
        const GetData = async () => {
            try {
                setIsLoading(true);
                const result = await UserService.getEmpresasyTareas();
                if (result) {
                    setData(result.data);

                    var dataNueva = result.data;
                    dataNueva.map(consola => {
                        setLeft(consola.tareas);
                    })
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    // props.history.push("/login");
                }
            } catch (e) {
                setIsLoading(false);
                // props.history.push("/login");
            }
        }
        GetData();
    }, []);

    const bodyQR = (
        <div className={styles.modal1}>
            <Excel url={values} />
        </div>
    )

    const inicio = () => {
        props.history.push(process.env.PUBLIC_URL + "/recursos")
    }

    return (
        <Paper className={classes.root}>

            <AppBar style={{ background: '#004F9E', alignItems: 'center' }} position="static">
                <Toolbar>
                    {isLoading && <CircularProgress color="secondary" />}

                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <ArrowBackIcon style={{ color: '#fff' }} onClick={() => inicio()} />
                    </IconButton>
                    <Typography variant="h4" component="div" style={{ color: '#fff' }} sx={{ flexGrow: 1 }}>
                        Informe de Recursos
                    </Typography>
                </Toolbar>
            </AppBar>
            <br />

            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>

                    {/*
                    <Grid item xs={4}>
                            <InputLabel htmlFor="outlined-age-native-simple">UP/Almacen</InputLabel>
                            <Select
                                native
                                label="UP/Almacen"
                                inputProps={{
                                    name: 'empresa',
                                    id: 'outlined-age-native-simple',
                                }}
                                value={formik.values.empresa}
                                //onChange={formik.handleChange}
                                onChange={handleChange}
                                error={formik.touched.empresa && Boolean(formik.errors.empresa)}
                                helperText={formik.touched.empresa && formik.errors.empresa}
                            >
                                <option aria-label="None" value="" />
                                {data.map((value) => (
                                    <option value={value.id} key={value.id}>
                                        {value.nombre}
                                    </option>
                                ))}
                            </Select>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel htmlFor="outlined-age-native-simple">Yacimiento</InputLabel>
                            <Select
                                native
                                label="Yacimiento"
                                inputProps={{
                                    name: 'yacimiento',
                                    id: 'outlined-age-native-simple',
                                }}
                                value={formik.values.yacimiento}
                                //onChange={formik.handleChange}
                                onChange={handleChange}
                                error={formik.touched.yacimiento && Boolean(formik.errors.yacimiento)}
                                helperText={formik.touched.yacimiento && formik.errors.yacimiento}
                            >
                                <option aria-label="None" value="" />
                                {datayacimientos.map((value) => (
                                    <option value={value.id} key={value.id}>
                                        {value.nombre}
                                    </option>
                                ))}
                            </Select>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel htmlFor="outlined-age-native-simple">Equipos</InputLabel>
                            <Select
                                native
                                label="Equipos"
                                inputProps={{
                                    name: 'equipo',
                                    id: 'outlined-age-native-simple',
                                }}
                                value={formik.values.equipo}
                                onChange={formik.handleChange}
                                error={formik.touched.equipo && Boolean(formik.errors.equipo)}
                                helperText={formik.touched.equipo && formik.errors.equipo}
                            >
                                <option aria-label="None" value="" />
                                {dataequipos.map((value) => (
                                    <option value={value.id} key={value.id}>
                                        {value.nombre}
                                    </option>
                                ))}
                            </Select>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                name="serie"
                                className={styles.inputMaterial}
                                label="Serie"
                                value={formik.values.serie}
                                onChange={formik.handleChange}
                                error={formik.touched.serie && Boolean(formik.errors.serie)}
                                helperText={formik.touched.serie && formik.errors.serie}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                name="sap"
                                className={styles.inputMaterial}
                                label="SAP"
                                value={formik.values.sap}
                                onChange={formik.handleChange}
                                error={formik.touched.sap && Boolean(formik.errors.sap)}
                                helperText={formik.touched.sap && formik.errors.sap}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel htmlFor="outlined-age-native-simple">Estado</InputLabel>
                            <Select
                                native
                                label="Estado"
                                value={formik.values.estado}
                                onChange={formik.handleChange}
                                error={formik.touched.estado && Boolean(formik.errors.estado)}
                                helperText={formik.touched.estado && formik.errors.estado}
                                inputProps={{
                                    name: 'estado',
                                    id: 'outlined-age-native-simple',
                                }}
                            >
                                <option aria-label="None" value="" />
                                {estado.map((value) => (
                                    <option value={value.id} key={value.id}>
                                        {value.nombre}
                                    </option>
                                ))}
                            </Select>
                        </Grid>
*/}
                    <Grid item xs={6}>
                        <TextField
                            id="date"
                            type="date"
                            defaultValue="2021-08-25"
                            name="fechainicio"
                            label="Fecha/carga desde:"
                            className={classes.textField}
                            error={formik.touched.fechainicio && Boolean(formik.errors.fechainicio)}
                            helperText={formik.touched.fechainicio && formik.errors.fechainicio}
                            onChange={formik.handleChange}
                            value={formik.values.fechainicio}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            id="date"
                            type="date"
                            defaultValue="2021-08-25"
                            name="fechafin"
                            label="Fecha/carga hasta:"
                            className={classes.textField}
                            error={formik.touched.fechafin && Boolean(formik.errors.fechafin)}
                            helperText={formik.touched.fechafin && formik.errors.fechafin}
                            onChange={formik.handleChange}
                            value={formik.values.fechafin}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                </Grid>

                <div align="right">
                    <Button color="primary" type="submit">Generar informe</Button>
                    <Button color="primary" onClick={() => cerrarEditar()}>Cancelar</Button>
                </div>
            </form>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"No fue posible generar el informe"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        El informe no posee datos.
                        Intenta modificar los datos de tu consulta.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal
                open={modalQR}
                onClose={abrirCerrarModalQR}>
                {bodyQR}
            </Modal>
        </Paper>
    );
}